import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showModal: true, submitting: false });
  if (pageComponent.state.componentDataSource.AppIntegrationTypeId === undefined) {
    httpClient
      .get('Admin/AppIntegrationType/GetSelectOptionList')
      .then(({ data }) => {
        if (data.result) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          dataSource = dataSource.filter(item => item.Value !== 0);
          componentDataSource.AppIntegrationTypeId = dataSource;
          pageComponent.setState({ componentDataSource });
          pageComponent.formRef.current?.setFieldValue('AppIntegrationTypeId', dataSource[0].Value);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    pageComponent.formRef.current?.setFieldValue('AppIntegrationTypeId', pageComponent.state.componentDataSource.AppIntegrationTypeId[0].Value);
  }
}

export function reloadAccountCode({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.appIntegrationTypeNameMenu.current?.setState({ flip: true });

  httpClient
    .post('Admin/AppIntegration/ReloadAccountCode', { appIntegrationId: parameter.key })
    .then(({ data }) => {
      if (data.result) {
        message.success('Sync account code successful');
      } else {
        message.error('Sync account code fail');
      }
      pageComponent.appIntegrationTypeNameMenu.current?.setState({ flip: false });
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function formatData({ parameter, sectionComponent, pageComponent } = {}) {
  parameter.map((item, i) => {
    if (item.AppIntegrationTypeId === 1) {
      httpClient
        .post('Admin/AppIntegration/CheckStatus', { appIntegrationId: item.key })
        .then(({ data }) => {
          if (data.result) {
            let oldData = sectionComponent.state.data.map((appIntegration, i) => {
              if (appIntegration.key === item.key) {
                appIntegration.Status = data.data;
              }
              return appIntegration;
            });
            setTimeout(() => {
              sectionComponent.setState({ data: [] });
              sectionComponent.setState({ data: oldData });
            }, 1);
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
  })
}

//展开菜单
export function showAppIntegrationMenu({ e, parameter, sectionComponent, pageComponent } = {}) {
  pageComponent.setState({ event: e, appIntegrationMenuShow: true, currentAppIntegration: parameter });
  e.preventDefault();
  return false;
}

//断开连接、清除token
export function disconnect({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .post('Admin/AppIntegration/Disconnect', { appIntegrationId: parameter.key })
    .then(({ data }) => {
      if (data.result) {
        message.success('Disconnect successful');
        pageComponent.createPage.current?.child[0].current?.getSectionDataByDefault();
      } else {
        message.error('Disconnect fail');
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
